import React, { useContext } from "react";
import propTypes from "prop-types";
import { HiMiniGiftTop } from "react-icons/hi2";
import { AuthContext } from "../../context/AuthContext";

export default function LinkMetrics({ link }) {
  const { user } = useContext(AuthContext);
  const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

  return (
    <div className="own-link-container">
      <div className="metrics-pfp">
        <img
          className="profile-pic"
          src={
            user && user.profilePicture
              ? user.profilePicture
              : `${cloudfrontUrl}/static/no-profile-pic.webp`
          }
          alt="Profile"
        />
      </div>
      <h3 className="link-metrics-title">Link Metrics</h3>
      {link.details.type === "currency" && (
        <div className="link-metrics-details-container">
          <div className="link-details-currency">${link.details.amount}</div>

          <div className="link-metrics-currency-details">
            <p className="link-metrics-currency-amount">
              Give ${link.details.amount}
            </p>
            <p className="link-metrics-expiration">Expires in 4 hours</p>
          </div>
        </div>
      )}
      {link.details.type === "item" && (
        <div className="link-metrics-details-container">
          <div className="link-metrics-item-img-container">
            <img
              className="link-metrics-item-img"
              src={link.details.photo}
              alt=""
            />
          </div>

          <div className="link-metrics-currency-details">
            <div className="link-metrics-title-container">
              <p className="link-metrics-item-title">
                Give this {link.details.title}
              </p>
            </div>
            <p className="link-metrics-expiration">Expires in 4 hours</p>
          </div>
        </div>
      )}
      <div className="link-metrics-table-container">
        {link.details.type === "currency" &&
        <>
            <div className="link-metrics-row">
            <p className="link-metrics-data">Available Quantitiy</p>
            <p className="link-metrics-data">{link.details.remainingQuantity}</p>
            </div>
            <hr className="link-metrics-row-hr" />
            <div className="link-metrics-row">
            <p className="link-metrics-data">Initial Quantitiy</p>
            <p className="link-metrics-data">{link.details.initialQuantity}</p>
            </div>
            <hr className="link-metrics-row-hr" />
        </>
        }
        <div className="link-metrics-row">
          <p className="link-metrics-data">Views</p>
          <p className="link-metrics-data">{link.metrics.views}</p>
        </div>
        <hr className="link-metrics-row-hr" />
        <div className="link-metrics-row">
          <p className="link-metrics-data">Visitors</p>
          <p className="link-metrics-data">{link.metrics.visitors.length}</p>
        </div>
      </div>
      <div className="subscribe-btn-container">
        <button className="link-metrics-sub-btn">
          Subscribe to see visitors
        </button>
      </div>
      <div className="metrics-logo-container">
        <HiMiniGiftTop className="metrics-logo"></HiMiniGiftTop>
      </div>
    </div>
  );
}

LinkMetrics.propTypes = {
  link: propTypes.object,
};
